import { render, staticRenderFns } from "./check-box.vue?vue&type=template&id=a6d0238e&scoped=true&"
import script from "./check-box.vue?vue&type=script&lang=js&"
export * from "./check-box.vue?vue&type=script&lang=js&"
import style0 from "./check-box.vue?vue&type=style&index=0&id=a6d0238e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d0238e",
  null
  
)

export default component.exports